







import {Component, Prop, Vue} from 'vue-property-decorator';

@Component
export default class EditIcon extends Vue {
    @Prop({type: String}) public title!: string;
}
